import React, { useEffect, useRef } from 'react';
import './WebProjects.css';
import ProjectCard from './ProjectCard';

import lotto from '../assets/lotto.png';
import g7fx from '../assets/g7fx.png';

import invisible from '../assets/invisible.webp';

const projects = [
  {
    title: 'Lotto Billions',
    paragraph: 'Lotto Billions expanded to Brazil in just 2 months by improving their web application',
    image: lotto,
    backgroundColor: '#feefe1',
  },
  {
    title: 'G7FX',
    paragraph: 'How G7FX crafted a seamless Discord community experience',
    image: g7fx,
    backgroundColor: '#e2f5f1',
  },
  {
    title: 'Invisible Homes',
    paragraph: 'Improved UX gets Invisible Homes over 35k registrants',
    image: invisible,
    backgroundColor: '#f1f4fa',
  },
];

const ProjectsSection = () => {
  const centerCardRef = useRef(null);
  const previousScrollY = useRef(window.scrollY);
  const yOffset = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      if (centerCardRef.current) {
        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffset.current + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffset.current = newOffset;

        centerCardRef.current.style.transform = `translate3d(0, ${newOffset}px, 0)`;
      }

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="projects-header879">
          <div className="projects-header-left">
            <h2>
              PROJECTS <br />
              <span className="blue-text">SUCESSFULLY DELIVERED</span>
            </h2>
          </div>
          <div className="projects-header-right">
            <p>
              Since 2020, we’ve delivered more than 300 web and software products, in over 15 different industries.
            </p>
          </div>
        </div>

        <div className="project-card-group">
          {projects.map((item, i) => (
            <div
              key={i}
              ref={i === 1 ? centerCardRef : null}
              className="project-card-wrapper"
            >
              <ProjectCard
                title={item.title}
                paragraph={item.paragraph}
                image={item.image}
                backgroundColor={item.backgroundColor}
                isCentered={i === 1}
              />
            </div>
          ))}
        </div>

        <div className="project-btn-wrapper">
          
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
